import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PublicEvent } from '@/pages/PublicEvent';
import { NotFound } from '@/pages/NotFound';

// Der Admin-Zweig liegt hinter Zero Trust und darf NICHT im oeffentlichen
// Bundle landen: /:slug ist die Anmeldeseite fuer Gaeste und ohne Login
// erreichbar — ein gemeinsames Bundle liefert den Admin-Code an jeden
// Eingeladenen mit aus, im Inspector lesbar. Kein Datenleck (Secrets
// serverseitig, /api/admin/* hinter ZT + JWT-Gate), aber Komponenten-,
// Routen- und API-Pfadnamen sind Aufklaerungsmaterial.
// Siehe 00_TRO_DEV_DOCS/public-frontend-check.md (Check B).
const AdminGate = lazy(() =>
  import('@/components/AdminGate').then((m) => ({ default: m.AdminGate }))
);
const AdminHome = lazy(() => import('@/pages/AdminHome').then((m) => ({ default: m.AdminHome })));
const AdminNew = lazy(() => import('@/pages/AdminNew').then((m) => ({ default: m.AdminNew })));
const AdminEvent = lazy(() =>
  import('@/pages/AdminEvent').then((m) => ({ default: m.AdminEvent }))
);
const AdminEventPrint = lazy(() =>
  import('@/pages/AdminEventPrint').then((m) => ({ default: m.AdminEventPrint }))
);

export default function App() {
  return (
    // Nur die Admin-Routen sind lazy — der Fallback erscheint also
    // ausschliesslich dort. Die oeffentliche Anmeldeseite bleibt statisch.
    <Suspense fallback={<AdminLoading />}>
      <Routes>
        {/* Admin */}
        <Route
          path="/admin"
          element={
            <AdminGate>
              <AdminHome />
            </AdminGate>
          }
        />
        <Route
          path="/admin/new"
          element={
            <AdminGate>
              <AdminNew />
            </AdminGate>
          }
        />
        <Route
          path="/admin/events/:id"
          element={
            <AdminGate>
              <AdminEvent />
            </AdminGate>
          }
        />
        <Route
          path="/admin/events/:id/print"
          element={
            <AdminGate>
              <AdminEventPrint />
            </AdminGate>
          }
        />

        {/* Public — Anmeldeseite nach Event-Slug. Root ohne Slug -> Not Found. */}
        <Route path="/" element={<NotFound />} />
        <Route path="/:slug" element={<PublicEvent />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}

function AdminLoading() {
  return <div style={{ padding: 24 }} />;
}
